class RecipeDetailExportOptionsController {

    constructor(moveFocus, analyticsService) {
        this.moveFocus = moveFocus;
        this.analyticsService = analyticsService;
        this.showPrintOption = this.enablePrint === undefined || this.enablePrint;
    }

    logPrintRecipeClick() {
        this.analyticsService.pushEvent(this.analyticsService.events.PRINT_RECIPE);
    }
}

const recipeDetailExportOptionsComponentDefinition = {
    bindings: {
        recipeId: '@',
        enablePrint: '=?',
    },
    controller: ['MoveFocus', 'AnalyticsService', RecipeDetailExportOptionsController],
    template: require('./recipe-detail-export-options.component.html').trim(),
};

module.exports = {
    RecipeDetailExportOptionsController,
    recipeDetailExportOptionsComponentDefinition,
};




// WEBPACK FOOTER //
// ./src/recipe/recipedetail/recipe-detail-export-options.component.js